/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { BrokerContactResponseDtoLabel } from './brokerContactResponseDtoLabel';
import type { BrokerContactResponseDtoType } from './brokerContactResponseDtoType';

export interface BrokerContactResponseDto {
  id: string;
  type: BrokerContactResponseDtoType;
  value: string;
  /** @nullable */
  label: BrokerContactResponseDtoLabel;
  isPrimary: boolean;
}
